import { render } from "./logo.vue?vue&type=template&id=56b92126&scoped=true"
import script from "./logo.vue?vue&type=script&lang=js"
export * from "./logo.vue?vue&type=script&lang=js"

import "./logo.vue?vue&type=style&index=0&id=56b92126&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b92126"]])

export default __exports__